import { render, staticRenderFns } from "./ServerContent.vue?vue&type=template&id=bcf8a2d0&scoped=true&"
import script from "./ServerContent.vue?vue&type=script&lang=js&"
export * from "./ServerContent.vue?vue&type=script&lang=js&"
import style0 from "./ServerContent.vue?vue&type=style&index=0&id=bcf8a2d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf8a2d0",
  null
  
)

export default component.exports